module.exports = __webpack_public_path__ + "img/icon_level1.4f543338.svg";